import { motion, AnimatePresence } from 'motion/react';

export function Breadcrumbs({ breadcrumbs, showBackground, categoriesPosition, onClick, logActivity }) {
  const allBreadcrumbs = [{ id: '__start__', name: 'Inicio' }, ...breadcrumbs];

  const handleClick = (breadcrumb) => {
    if (onClick) {
      onClick(breadcrumb);
      logActivity('breadcrumbs-list', 'breadcrumb', 'click', true, {id: breadcrumb.id, name: breadcrumb.label ||breadcrumb.name});
    }
  };

  const breadcrumbStyle = () => {
    return {
      color: 'var(--tag-color)',
      backgroundColor: 'var(--tag-bg)'
    };
  };

  // SOK-09: la punta mide la mitad del alto del tag (py-4 + una línea de text-base) y crece con
  // "Letra grande"; con 28px fijos quedaba más baja que el tag.
  const arrowSize = 'calc(16px + 12px * var(--fs-scale, 1))';

  const triangleStyle = () => {
    return {
      width: 0,
      height: 0,
      right: `calc(1px - ${arrowSize})`,
      borderTop: `${arrowSize} solid transparent`,
      borderBottom: `${arrowSize} solid transparent`,
      borderLeft: `${arrowSize} solid var(--tag-bg)`,
    };
  };

  const renderBreadcrumbs = () => {
    const sortedBreadcrumbs = allBreadcrumbs.sort((a, b) => a.deep_level - b.deep_level);
    return sortedBreadcrumbs.map((breadcrumb, index) => (
      <motion.div
        key={breadcrumb.id}
        className="relative w-auto h-auto inline-block mt-4 mb-4 mr-10 last:mr-0 cursor-pointer"
        whileHover={{ y: -7 }}
        whileTap={{ scale: 0.8 }}
      >
        <div className={`pl-6 ${index === sortedBreadcrumbs.length - 1 ? 'pr-6 rounded-tr-[10px] rounded-br-[10px]' : 'pr-3 rounded-tr-[2px] rounded-br-[2px]'} py-4 rounded-tl-[10px] rounded-bl-[10px] text-base uppercase`} onClick={() => handleClick(breadcrumb)} style={breadcrumbStyle()}>
          {breadcrumb.label || breadcrumb.name}
        </div>
        {index === sortedBreadcrumbs.length - 1 ? null : <div className="absolute top-[0px]" style={triangleStyle()}></div>}
      </motion.div>
    ));
  };

  return (
    <div className={`w-full overflow-x-auto no-scrollbar whitespace-nowrap ${categoriesPosition === 'top' ? 'px-8' : 'px-4'} pt-2 ${showBackground ? 'bg-mid' : ''} secondary-font-bold`}>
      {renderBreadcrumbs()}
    </div>
  );
}